var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.uLang('app.edit'),"header-tag":"h4"}},[_c('log-form',{attrs:{"entityType":"organisations","entityId":_vm.organisationId,"override-endpoint":_vm.overrideEndpoint,"id":_vm.logId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }